// extracted by mini-css-extract-plugin
module.exports = {"calc_progress":"Progress_calc_progress__1fInl"};